'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = authService;

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _remove = require('lodash/remove');

var _remove2 = _interopRequireDefault(_remove);

var _reduce = require('lodash/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _tuneInRequest = require('../tuneInRequest');

var _tuneInRequest2 = _interopRequireDefault(_tuneInRequest);

var _OpmlError = require('../errors/OpmlError');

var _ApiError = require('../errors/ApiError');

var _ApiError2 = _interopRequireDefault(_ApiError);

var _transformOpmlResponseData = require('../utils/transformOpmlResponseData');

var _transformOpmlResponseData2 = _interopRequireDefault(_transformOpmlResponseData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function authService(config, apiContext, applyReauth) {
  var _config$domains = config.domains,
      _config$domains$opml = _config$domains.opml,
      opml = _config$domains$opml === undefined ? '' : _config$domains$opml,
      _config$domains$local = _config$domains.local,
      local = _config$domains$local === undefined ? '' : _config$domains$local,
      _config$domains$coreA = _config$domains.coreApi,
      coreApi = _config$domains$coreA === undefined ? '' : _config$domains$coreA;

  var accountEndpoint = opml + '/Account.ashx';
  var proxyEndpoint = local + '/auth';
  var loginResponseOmittedProps = ['element', 'text', 'guideId', 'key'];
  var partnerReauthEndpoint = coreApi + '/account/refresh';
  var coreApiHostname = coreApi.substring(8);

  // Functions for transforming/modeling responses
  function loginTransformPredicate(item) {
    return item.key === 'oauth';
  }

  function transformOpmlResponse(data) {
    // There are cases where OPML returns markup as the response body, which becomes a string
    // (most of these cases deal with non-200 responses from OPML that actually return a non-200
    // status code). Let's not transform such response bodies, and just pass them through to other
    // response handlers.
    if ((0, _isObject2.default)(data)) {
      var tokenData = (0, _first2.default)((0, _remove2.default)(data.body, loginTransformPredicate));
      var userData = (0, _reduce2.default)(data.body, function (result, value) {
        return _extends({}, result, value);
      });

      (0, _transformOpmlResponseData2.default)(data);

      return {
        head: data.head,
        tokenData: (0, _omit2.default)(tokenData, loginResponseOmittedProps),
        userData: (0, _omit2.default)(userData, loginResponseOmittedProps)
      };
    }

    return data;
  }

  function handleNoAuthData(response) {
    if ((0, _isEmpty2.default)(response.data.tokenData) || (0, _isEmpty2.default)(response.data.userData)) {
      throw new _ApiError2.default({
        message: 'Token/user data should not be empty',
        response: response,
        doNotIncludeStatus: true
      });
    }

    return response;
  }

  function handleAccountAuthPromise(apiPromise) {
    return apiPromise.then(_OpmlError.handleOpmlError).then(handleNoAuthData).then(function (response) {
      apiContext.setTokens(response.data.tokenData);

      return response;
    });
  }

  function handleLogoutPromise(apiPromise) {
    return apiPromise.then(_OpmlError.handleOpmlError).then(function (response) {
      apiContext.clearTokens();

      return response;
    });
  }

  // API functions and related proxy/local requests
  function proxyTuneInCommandRequest(endpoint, details) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: proxyEndpoint + '/' + endpoint + '/',
      isAjax: true,
      data: details,
      disableRetry: true
    }, apiContext);
  }

  function proxyEmailLogin(details) {
    var accountApiPromise = proxyTuneInCommandRequest('emailLogin', details);

    return handleAccountAuthPromise(accountApiPromise);
  }

  function proxyEmailVerification(details) {
    var accountApiPromise = proxyTuneInCommandRequest('emailVerification', details);

    return accountApiPromise.then(_OpmlError.handleOpmlError);
  }

  function tuneInEmailCommandRequest(command, generateAuth, details) {
    var username = details.username,
        password = details.password,
        reCAPTCHAResponse = details.reCAPTCHAResponse,
        params = details.params;

    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountEndpoint,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: _extends({}, params, {
        c: command,
        render: 'json'
      }),
      data: _qs2.default.stringify({
        generateAuth: generateAuth,
        username: username,
        password: password,
        'g-recaptcha-response': reCAPTCHAResponse
      }),
      transformResponse: transformOpmlResponse,
      disableRetry: true
    }, apiContext);
  }

  function emailVerification(details) {
    var accountApiPromise = tuneInEmailCommandRequest('verify', false, details);

    return accountApiPromise.then(_OpmlError.handleOpmlError);
  }

  function emailLogin(details) {
    var accountApiPromise = tuneInEmailCommandRequest('login', true, details);

    return handleAccountAuthPromise(accountApiPromise);
  }

  function proxyTuneInOauthCommandRequest(endpoint, providerName, data, params) {
    var userId = data.userId,
        token = data.token,
        firstName = data.firstName,
        lastName = data.lastName;


    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: proxyEndpoint + '/' + endpoint + '/',
      isAjax: true,
      data: {
        providerName: providerName,
        userId: userId,
        token: token,
        params: params,
        firstName: firstName,
        lastName: lastName
      }
    }, apiContext);
  }

  function proxyOauthVerification(providerName, data, params) {
    var accountApiPromise = proxyTuneInOauthCommandRequest('oauthVerification', providerName, data, params);

    return accountApiPromise.then(_OpmlError.handleOpmlError);
  }

  function proxyOauthLogin(providerName, data, params) {
    var accountApiPromise = proxyTuneInOauthCommandRequest('oauthLogin', providerName, data, params);

    return handleAccountAuthPromise(accountApiPromise);
  }

  function tuneInOauthCommandRequest(command, generateAuth, details) {
    var providerName = details.providerName,
        userId = details.userId,
        token = details.token,
        params = details.params,
        firstName = details.firstName,
        lastName = details.lastName;

    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountEndpoint,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: _extends({}, params, {
        c: command,
        render: 'json'
      }),
      data: _qs2.default.stringify({
        generateAuth: generateAuth,
        providerName: providerName,
        linkedProviderName: providerName,
        externalId: userId,
        linkedExternalId: userId,
        providerToken: token,
        linkedProviderToken: token,
        firstName: firstName,
        lastName: lastName
      }),
      transformResponse: transformOpmlResponse
    }, apiContext);
  }

  function oauthVerification(details) {
    var accountApiPromise = tuneInOauthCommandRequest('verify', false, details);

    return accountApiPromise.then(_OpmlError.handleOpmlError);
  }

  function oauthLogin(details) {
    var accountApiPromise = tuneInOauthCommandRequest('login', true, details);

    return handleAccountAuthPromise(accountApiPromise);
  }

  function createAccount(creds) {
    var accountApiPromise = (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountEndpoint,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: _extends({}, creds.params, {
        c: 'create',
        render: 'json'
      }),
      data: _qs2.default.stringify(_extends({
        generateAuth: true
      }, (0, _omit2.default)(creds, 'params'))),
      transformResponse: transformOpmlResponse,
      disableRetry: true
    }, apiContext);

    return handleAccountAuthPromise(accountApiPromise);
  }

  function proxyCreateAccount(data) {
    var accountApiPromise = (0, _tuneInRequest2.default)({
      method: 'post',
      url: proxyEndpoint + '/createAccount/',
      isAjax: true,
      data: data,
      disableRetry: true
    }, apiContext);

    return handleAccountAuthPromise(accountApiPromise);
  }

  function premiumUnlock(params) {
    var accountApiPromise = (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountEndpoint,
      params: {
        c: 'unlockContent',
        render: 'json',
        campaignId: params.campaignId,
        unlockProviderData: params.unlockProviderData,
        unlockToken: params.unlockToken
      },
      disableCamelCase: true
    }, apiContext);

    return accountApiPromise.then(_OpmlError.handleOpmlError);
  }

  function addDevice(params) {
    var accountApiPromise = (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountEndpoint,
      params: {
        c: 'join',
        render: 'json',
        partnerId: params.partnerId,
        serial: params.serial
      },
      disableCamelCase: true
    }, apiContext);

    return accountApiPromise.then(_OpmlError.handleOpmlError);
  }

  function proxyAddDevice(data) {
    var accountApiPromise = (0, _tuneInRequest2.default)({
      method: 'post',
      url: proxyEndpoint + '/addDevice/',
      isAjax: true,
      data: data,
      disableRetry: true
    }, apiContext);

    return accountApiPromise.then(_OpmlError.handleOpmlError);
  }

  function logout() {
    var apiPromise = (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountEndpoint,
      params: {
        c: 'drop',
        render: 'json'
      },
      transformResponse: transformOpmlResponse,
      disableRetry: true
    }, apiContext);

    return handleLogoutPromise(apiPromise);
  }

  function proxyLogout() {
    var apiPromise = (0, _tuneInRequest2.default)({
      method: 'post',
      url: proxyEndpoint + '/logout/',
      isAjax: true,
      disableRetry: true
    }, apiContext);

    return handleLogoutPromise(apiPromise);
  }

  function forgotPassword(email) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountEndpoint,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        c: 'reset',
        render: 'json'
      },
      data: _qs2.default.stringify({
        email: email
      }),
      transformResponse: transformOpmlResponse
    }, apiContext).then(_OpmlError.handleOpmlError);
  }

  function createChangeRequest(command, params) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountEndpoint,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        c: command,
        render: 'json'
      },
      data: _qs2.default.stringify(_extends({}, params)),
      transformResponse: transformOpmlResponse
    }, apiContext).then(_OpmlError.handleOpmlError);
  }

  function resetPassword(userToken, newPassword) {
    return createChangeRequest('changePassword', { userToken: userToken, newPassword: newPassword });
  }

  function changePassword(password, newPassword) {
    return createChangeRequest('changePassword', { password: password, newPassword: newPassword });
  }

  function changeUsername(newUsername) {
    return createChangeRequest('changeUsername', { newUsername: newUsername });
  }

  function partnerReauth(data, apiKey) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: partnerReauthEndpoint,
      data: data,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
        host: coreApiHostname
      },
      disableRetry: true,
      withoutParams: true
    }, apiContext).then(_OpmlError.handleOpmlError);
  }

  function proxyDesktopGoogleAuthLogin(data) {
    var accountApiPromise = proxyTuneInCommandRequest('desktopGoogleAuth', data);

    return accountApiPromise.then(function (response) {
      apiContext.setTokens(response.data.tokenData);

      return response.data;
    });
  }

  return {
    emailVerification: emailVerification,
    emailLogin: emailLogin,
    logout: applyReauth(logout),
    oauthLogin: oauthLogin,
    oauthVerification: oauthVerification,
    createAccount: createAccount,
    premiumUnlock: applyReauth(premiumUnlock),
    addDevice: applyReauth(addDevice),
    proxyAddDevice: proxyAddDevice,
    proxyEmailVerification: proxyEmailVerification,
    proxyEmailLogin: proxyEmailLogin,
    proxyOauthLogin: proxyOauthLogin,
    proxyOauthVerification: proxyOauthVerification,
    proxyDesktopGoogleAuthLogin: proxyDesktopGoogleAuthLogin,
    proxyCreateAccount: proxyCreateAccount,
    proxyLogout: proxyLogout,
    forgotPassword: forgotPassword,
    resetPassword: resetPassword,
    partnerReauth: partnerReauth,
    changePassword: applyReauth(changePassword),
    changeUsername: applyReauth(changeUsername)
  };
}
//# sourceMappingURL=auth.js.map